import { FieldArray } from "formik";
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Button, Grid, IconButton } from "@mui/material";
import { configState } from '../../../../../recoil/atoms';
import { IconListDetails, IconTrash } from "@tabler/icons";
import { InputField } from "../../../../../utils/FormFields";
import CircularProgress from '@mui/material/CircularProgress';
import { InventoryApi } from '../../../../../api/medical-operations';
import { FormikProps, FormikValues, useFormikContext } from 'formik';

export default function InventoryItems() {
  const config = useRecoilValue(configState);

  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<readonly any[]>([]);
  const [inventoryItem, setInventoryItem] = useState<any>([]);  
  const formik: FormikProps<FormikValues> = useFormikContext();
  
  const loading = open && options.length === 0;

  const getInventoryItems = (item: string) => {    
    const Inventory = new InventoryApi(config);
    Inventory.getInventoryItemsByName(item)
      .then((res) => {
        setInventoryItem(res.data.items!);
        setOptions(res.data.items!)        
      })
      .catch((err) => {           
        toast.error(err?.response?.data?.detail);
      });
  };

  const onInputChange = (event: any, value: string, reason: any) => {
    if (value) {
      getInventoryItems(value);
    } else {
      setOptions([]);
    }
  };  

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <>
      <Grid container rowSpacing={2} spacing={1} sx={{ pt: 4, justifyContent: "center", alignContent: "center" }}>
        <FieldArray
          name="inventory_items"
          render={(arrayHelpers) => (
            <>
              <Button
                onClick={() => {
                  arrayHelpers.push({ id: "", qty: 1 });
                }}
                color="primary"
                variant="outlined"                
              >
                <IconListDetails />
                Add Item
              </Button>
              <Grid container />
              {formik?.values?.inventory_items.map((item: any, index: number) => (
                <>
                  <Grid item xs={12} sm={7} key={index+item}>
                    <Autocomplete
                      key={index}
                      autoHighlight
                      options={options}
                      onOpen={() => {
                        setOpen(true);
                      }}
                      onClose={() => {
                        setOpen(false);
                      }}
                      getOptionLabel={(option) => option.Name!}
                      sx={{ width: '100%' }}
                      onChange={(event, value) => {                        
                        const updatedItems = [...formik.values.inventory_items];
                        updatedItems[index] = { id: value.ItemID, qty: item.qty || 1 }; 
                        formik.setFieldValue("inventory_items", updatedItems);
                      }}                      
                      loading={loading}
                      filterOptions={(options, state) => (options)}
                      onInputChange={onInputChange}
                      isOptionEqualToValue={(option, value) => option.Name === value.Name}
                      renderInput={(params) => {
                        return (
                          <TextField                          
                          {...params}
                          fullWidth
                          label="Inventory Items"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                        );
                      }}
                    />                    
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputField name={`inventory_items[${index}].qty`} type={"number"}  label="Quantity" fullWidth defaultValue={1}/>
                  </Grid>
                  <Grid item xs={4} sm={1}>
                    <IconButton onClick={() => arrayHelpers.remove(index)}>
                      <IconTrash color="red" />
                    </IconButton>
                  </Grid>
                  <Grid container />
                </>
              ))}
            </>
          )}
        />
      </Grid>
    </>
  );
}
